var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "evaArrowBackFill0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "evaArrowBackFill1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "evaArrowBackFill2",
    d: "M16.9375 7.42934H4.33625L8.19313 2.75833C8.37347 2.53954 8.46024 2.25748 8.43433 1.97419C8.40843 1.6909 8.27198 1.42959 8.055 1.24775C7.83802 1.0659 7.55828 0.978415 7.27733 1.00453C6.99638 1.03065 6.73722 1.16824 6.55687 1.38702L1.24438 7.81502C1.20863 7.86615 1.17667 7.91986 1.14875 7.97572C1.14875 8.02928 1.14875 8.06142 1.07438 8.11499C1.02622 8.23783 1.001 8.36859 1 8.50067C1.001 8.63275 1.02622 8.76351 1.07438 8.88635C1.07438 8.93992 1.07437 8.97206 1.14875 9.02562C1.17667 9.08148 1.20863 9.13519 1.24438 9.18632L6.55687 15.6143C6.65677 15.7353 6.78187 15.8325 6.92327 15.8992C7.06468 15.9658 7.21891 16.0003 7.375 16C7.62326 16.0005 7.86384 15.9133 8.055 15.7536C8.16259 15.6637 8.25152 15.5532 8.31671 15.4286C8.38189 15.3039 8.42205 15.1675 8.43488 15.0272C8.44771 14.8869 8.43296 14.7454 8.39148 14.6108C8.34999 14.4763 8.28259 14.3513 8.19313 14.243L4.33625 9.572H16.9375C17.2193 9.572 17.4895 9.45913 17.6888 9.25822C17.8881 9.0573 18 8.7848 18 8.50067C18 8.21653 17.8881 7.94404 17.6888 7.74312C17.4895 7.54221 17.2193 7.42934 16.9375 7.42934Z",
    fill: "black",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.42782adb4b24c28ad53b592af3158771.svg";
export { ForwardRef as ReactComponent };